module.exports = __webpack_public_path__ + "img/huanhuo_h5.ea24999.png";